import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { ProductImageModel } from '../models/product-image.model';

export class ProductImagesApiService extends ApiService {
  static endpoint = 'product-images';

  /**
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUrl(), {
      ...config,
      dataModel: ProductImageModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
